import { flatMap, has } from "lodash";
import { useReducer } from "react";
import { toast } from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Master {
  unitData: object;
  siteUnitData: object;
  siteDocumentData: object;
  memberDocumentData: object;
  memberDataBySiteId: any;
  siteByIdData: object;
  developerWiseData: object;
  projectTypesData: any;
  error: string;
  isImportSuccess: boolean;
  memberEditData: object;
  projectSiteFilterData: any;
  developerSiteFilterData: object;
}

const initialArgs: Master = {
  unitData: {},
  siteUnitData: {},
  siteDocumentData: {},
  memberDocumentData: {},
  memberDataBySiteId: [],
  siteByIdData: {},
  developerWiseData: {},
  projectTypesData: [],
  error: "",
  isImportSuccess: false,
  memberEditData: {},
  projectSiteFilterData: [],
  developerSiteFilterData: {},
};

const reducer = (state: Master, action: Master) => {
  return { ...state, ...action };
};

const useProjectSite = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getProjectSite = async (
    developerId: any,
    page: string,
    listPerPage: string,
    searchValue: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/site/developer?developer=${developerId}&page=${page}&pageSize=${listPerPage}&searchValue=${searchValue}&sort=${sort === undefined ? "" : sort}&order=${order === undefined ? "" : order}`,
        // `/api/site/developer?developer=66b5aee1afe69e1bf080a8b1&page=${page}&pageSize=${listPerPage}&searchValue=${searchValue}&sort=${sort === undefined ? "" : sort}&order=${order === undefined ? "" : order}`,
      );
      // `/api/site/developer?developer=${developerId}&page=${page}&pageSize=${pageSize}&searchValue=${searchValue}&sort=${sort}&order=${order}`,

      if (result.data.status) {
        setState({
          ...state,
          developerWiseData: result.data.data[0],
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getSiteUnit = async (
    siteId: any,
    page: string = "1",
    listPerPage: string = "10",
    searchValue: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/site/unit/?site=${siteId}&page=${page || "1"}&pageSize=${listPerPage || "10"}&searchValue=${searchValue}&sort=${sort === undefined ? "" : sort}&order=${order === undefined ? "" : order}`,
        // `/api/site/unit/?page=${page}&pageSize=${pageSize}&searchValue=${searchValue}&sort=${sort}&order=${order}/66b2068f9ea3a824836d1058`,
      );

      if (result.data.status) {
        setState({
          ...state,
          siteUnitData: result.data.data[0],
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const getSiteDocument = async (siteId: any) => {
    try {
      const result: any = await api.get(
        `/api/site-document/type?type=project-site-documents&site=${siteId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          siteDocumentData: result?.data?.data,
        });

        return true;
      } else {
        const errorStr = has(result?.data, "errors")
          ? Object(flatMap(result?.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const createProjectSite = async (paramObj: any) => {
    console.log(">> paramObj", paramObj);

    try {
      const result: any = await api.post(`/api/site`, paramObj, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("Create Project Site =>", result);

      if (result.data.status) {
        /* setState({
          ...state,
          siteByIdData: result.data.data,
        }); */

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        //setState({ ...state, error: errorStr });
        toast.error(errorStr);
        return false;
      }
    } catch (error: any) {
      //setState({ ...state, error: error.message });
      toast.error(error.message);
      return false;
    }
  };

  const getProjectSiteById = async (siteId: any) => {
    try {
      setState({
        ...state,
        siteByIdData: {},
      });
      const result: any = await api.get(`/api/site/${siteId}`);
      // `/api/site/${siteId}`,

      if (result.data.status) {
        setState({
          ...state,
          siteByIdData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const uploadSiteDocument = async (siteDocument: any) => {
    console.log("siteDocumentsiteDocument", siteDocument);

    try {
      const result: any = await api.postForm(
        `/api/site-document`,
        siteDocument,
      );

      if (result.data.status) {
        toast.success(result.data.message);
        return { status: true, data: result.data.data };
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  //Update Project Site
  const updateProjectSite = async (
    projectSiteId: any,
    projectSiteData: any,
  ) => {
    const paramObj = {
      ...projectSiteData,
    };
    try {
      const { data } = await api.put(`/api/site/${projectSiteId}`, paramObj, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (data.status === true) {
        toast.success(data.message);
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };

  //Update Unit API
  const updateUnit = async (unitId: any, unitData: any) => {
    const paramObj = {
      ...unitData,
    };
    console.log("paramObjUpdateUnit => ", paramObj);

    try {
      const { data } = await api.put(`/api/unit/${unitId}`, paramObj);

      if (data.status === true) {
        toast.success(data.message);
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };

  //Update Unit API
  const checkExistingUnit = async (unitData: any, unitId: number) => {
    const { blockNo, unitNo, site } = unitData;

    try {
      const { data } = await api.get(
        `/api/unit/duplicate-unit/${unitId}?blockNo=${blockNo}&unitNo=${unitNo}&site=${site}`,
      );

      if (data.status === true) {
        return data.existUnit || false;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };

  //Create Unit API
  const createUnit = async (unitData: any) => {
    const paramObj = {
      ...unitData,
    };
    console.log("paramObjforCreateUnit => ", paramObj);

    try {
      // const formData = new FormData();
      const result: any = await api.post("/api/unit", paramObj);
      console.log("resultfromPostApi => ", result);

      if (result.data.status) {
        toast.success(result.data.message);
        setState({ ...state, unitData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const deleteSiteDocument = async (siteId: string) => {
    console.log("siteIdsiteId", siteId);
    try {
      const { data } = await api.delete(`/api/site-document/${siteId}`);

      if (data.status === true) {
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };
  const deleteMemberDocument = async (mermberDocumentId: string) => {
    try {
      const { data } = await api.delete(
        `/api/member-document/${mermberDocumentId}`,
      );

      if (data.status === true) {
        toast.success(data?.message);
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };

  const getProjectTypeList = async () => {
    try {
      const { data } = await api.get(`/api/setting/type?type=project-type`);

      if (data.status === true) {
        const filteredProjectTypesData = data?.data.map((item: any) => {
          return { ...item, id: item._id };
        });
        setState({ ...state, projectTypesData: filteredProjectTypesData });
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };
  const getMemberBySite = async (
    page: string,
    pageSize: string,
    searchValue: string,
    sort: string,
    order: string,
    siteId: any,
  ) => {
    try {
      const result: any = await api.get(
        `/api/member?page=${page}&pageSize=${pageSize}&searchValue=${searchValue}&sort=${sort}&order=${order}&site=${siteId}`,
        // `/api/site/developer?developer=66b5aee1afe69e1bf080a8b1&page=${page}&pageSize=${pageSize}&searchValue=${searchValue}&sort=${sort}&order=${order}`,
      );
      // `/api/member?site=${siteId}&page=${page}&pageSize=${listPerPage}`,

      if (result.data.status) {
        setState({
          ...state,
          memberDataBySiteId: result.data.data[0],
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  //Import UNIT API
  const importUnit = async (siteId: string, param: any) => {
    const paramObj = {
      file: param.files,
    };
    let resetImportToast;
    setState({ ...state, isImportSuccess: false });

    try {
      const result: any = await api.post(
        `/api/unit/import/${siteId}`,
        paramObj,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      //console.log("result => ", result);

      if (result.data.status) {
        resetImportToast = toast.success(result.data.message, {
          id: resetImportToast,
        });
        setState({ ...state, isImportSuccess: true });
        return result.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr, { id: resetImportToast });
        setState({ ...state, error: errorStr });
        return result.data;
      }
    } catch (error: any) {
      toast.error(error.message, { id: resetImportToast });
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const addMembersInUnits = async (paramObj: any) => {
    console.log(">> paramObj", paramObj);

    try {
      const result: any = await api.post(`/api/member`, paramObj);
      console.log("Create Project Site =>", result);

      if (result.data.status) {
        /* setState({
          ...state,
          siteByIdData: result.data.data,
        }); */
        toast.success(result?.data?.message);
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        //setState({ ...state, error: errorStr });
        toast.error(errorStr);
        return false;
      }
    } catch (error: any) {
      //setState({ ...state, error: error.message });
      toast.error(error.message);
      return false;
    }
  };

  //Edit Member Unit
  const getMemberById = async (memberId: string) => {
    try {
      const result: any = await api.get(`/api/member/${memberId}`);

      // console.log("result: ", result.data.data);

      if (result.data.status) {
        //setState({ ...state, memberEditData: result.data.data });
        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        //setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      //setState({ ...state, error: error.message });
      return false;
    }
  };
  const getUnitById = async (unitId: string) => {
    try {
      const result: any = await api.get(`/api/unit/${unitId}`);

      // console.log("result: ", result.data.data);

      if (result.data.status) {
        //setState({ ...state, memberEditData: result.data.data });
        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        //setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      //setState({ ...state, error: error.message });
      return false;
    }
  };

  //Update Member
  const updateMember = async (memberId: string, param: any) => {
    const paramObj = {
      ...param,
    };
    console.log("paramObjUpdateMember => ", paramObj);

    try {
      const { data } = await api.put(`/api/member/${memberId}`, paramObj);

      if (data.status === true) {
        toast.success(data.message);
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };

  //Member Document
  const getMemberDocument = async (memberId: string) => {
    try {
      const result: any = await api.get(
        `/api/member-document/type?type=member-documents&member=${memberId}`,
      );
      //console.log("result => ", result);

      if (result.data.status) {
        setState({
          ...state,
          memberDocumentData: result?.data?.data,
        });

        return true;
      } else {
        const errorStr = has(result?.data, "errors")
          ? Object(flatMap(result?.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  //Member Upload Document
  const uploadMemberDocument = async (memberDocument: any) => {
    console.log("Member Document", memberDocument);

    try {
      const result: any = await api.postForm(
        `/api/member-document`,
        memberDocument,
      );
      console.log("resultforMemberDocument => ", result);

      if (result.data.status) {
        toast.success(result.data.message);
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };

  /* Site Filter Api Start */
  // const getProjectSiteFilter = async (
  //   page: string,
  //   pageSize: string,
  //   searchValue: string,
  //   sort: string,
  //   order: string,
  //   developerId: string,
  //   cityId: string,
  //   landmarkId: string,
  //   projectTypeId: string,
  // ) => {
  //   try {
  //     setState({
  //       ...state,
  //       projectSiteFilterData: [],
  //     });
  //     const result: any = await api.get(
  //       `/api/site/filter?page=${page}&pageSize=${pageSize}&order=${order}&searchValue=${searchValue}&sort=${sort}&developer=${developerId}&city=${cityId}&landmark=${landmarkId}&projectType=${projectTypeId}`,
  //     );

  //     if (result.data.status) {
  //       console.log(result.data.data[0], "--------result.data.data[0]---");
  //       setState({
  //         ...state,
  //         projectSiteFilterData: result.data.data[0],
  //       });

  //       return true;
  //     } else {
  //       const errorStr = has(result.data, "errors")
  //         ? Object(flatMap(result.data))[1].msg
  //         : result.data.message;
  //       toast.error(errorStr);
  //       //setState({ ...state, error: errorStr });
  //       return false;
  //     }
  //   } catch (error: any) {
  //     //setState({ ...state, error: error.message });
  //     return false;
  //   }
  // };
  /* Site Filter Api End */

  /* Developer Wise Site API Start*/
  const getDeveloperWiseSite = async () => {
    try {
      const result: any = await api.get(
        `/api/site/developerWiseAllSite?developer=${"66b5aee1afe69e1bf080a8b1"}`,
      );
      console.log("result for developer wise Site => ", result);

      if (result.data.status) {
        setState({
          ...state,
          developerSiteFilterData: result.data.data[0].rows,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const shareSiteDocument = async (shareDocument: any) => {
    try {
      const result: any = await api.post(
        `/api/site-document/sendDocument`,
        shareDocument,
      );
      console.log("result", result);

      if (result.data.status) {
        toast.success(result.data.message);
        return { status: true, data: result.data.data };
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const shareMemberDocument = async (shareDocument: any) => {
    try {
      const result: any = await api.post(
        `/api/member-document/sendDocument`,
        shareDocument,
      );
      console.log("result", result);

      if (result.data.status) {
        toast.success(result.data.message);
        return { status: true, data: result.data.data };
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  /* Developer Wise Site API End*/

  return {
    createProjectSite,
    getProjectSite,
    getSiteUnit,
    getProjectSiteById,
    getSiteDocument,
    uploadSiteDocument,
    updateProjectSite,
    updateUnit,
    deleteSiteDocument,
    deleteMemberDocument,
    createUnit,
    getMemberBySite,
    getProjectTypeList,
    importUnit,
    addMembersInUnits,
    getMemberById,
    updateMember,
    getMemberDocument,
    uploadMemberDocument,
    getDeveloperWiseSite,
    shareSiteDocument,
    shareMemberDocument,
    getUnitById,
    checkExistingUnit,
    ...state,
  };
};

export default useProjectSite;
